import { render, staticRenderFns } from "./editDollarRate.vue?vue&type=template&id=19dd57b8&scoped=true&"
import script from "./editDollarRate.vue?vue&type=script&lang=js&"
export * from "./editDollarRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dd57b8",
  null
  
)

export default component.exports